export default __webpack_public_path__ + "static/oldbooking-ba51f998bc08c7011f77b2689b4d6ebb.png";